import { Route, Routes, useLocation } from "react-router-dom";
import Dashboard from "@/pages/Dashboard";
import Profile from "@/pages/Profile";
import AdminList from "@/pages/admin/AdminList";
import AddBrand from "@/pages/brands/AddBrand";
import BrandDetails from "@/pages/brands/BrandDetails";
import DirectoryService from "@/pages/directoryservice/DirectoryService";
import TemplateList from "@/pages/templates/TemplateList";
import FormList from "@/pages/forms/FormList";
import TemplateDetails from "@/pages/templates/TemplateDetails";
import TemplateEnvelopeList from "@/pages/templates/TemplateEnvelopeList";
import BrandList from "@/pages/brands/BrandList";
import CreateGroup from "@/pages/groups/CreateGroup";
import EditGroup from "@/pages/groups/EditGroup";
import GroupList from "@/pages/groups/GroupList";
import { AzureRegistration } from "@/pages/integration/AzureRegistration";
import CreateRole from "@/pages/roles/CreateRole";
import EditRole from "@/pages/roles/EditRole";
import RoleList from "@/pages/roles/RoleList";
import Setting from "@/pages/settings/Setting";
import InviteUser from "@/pages/users/InviteUser";
import UpdateUserGroups from "@/pages/users/UpdateUserGroups";
import UpdateUserRoles from "@/pages/users/UpdateUserRoles";
import UserGroup from "@/pages/users/UserGroup";
import UserList from "@/pages/users/UserList";
import UserRole from "@/pages/users/UserRole";
import EnvelopeDetail from "@/pages/envelopes/EnvelopeDetails";
import GroupDetails from "@/pages/groups/GroupDetails";
import RoleDetails from "@/pages/roles/RoleDetails";
import UserDetails from "@/pages/users/UserDetails";
import CreateSharedAccess from "@/pages/sharedAccess/CreateSharedAccess";
import FormDetails from "@/pages/forms/FormDetails";
import TagsList from "@/pages/tags/TagsList";
import SharedAccess from "@/pages/sharedAccess/SharedAccess";
import EnvelopeList from "@/pages/envelopes/EnvelopeList";
import AuditLogs from "@/pages/auditLogs/AuditLogsList";
import ManageAi from "@/pages/ai/ManageAi";
import AiConfigurations from "@/pages/ai/AiConfiguration";
import ReportedUsers from "@/pages/reportedUsers/ReportedUsers";
import ReportedUserDetail from "@/pages/reportedUsers/ReportedUserDetail";
import ReportedEnvelopeDetails from "@/pages/reportedUsers/ReportedEnvelopeDetails";

type Props = {};

const SideBarRoutes = (_props: Props) => {
    const location = useLocation();

    return (
        <div className="gs-page-enter">
            <Routes location={location}>
                <Route key="/" path="/" element={<Dashboard />} />
                <Route key="/dashboard" path="/dashboard" element={<Dashboard />} />
                <Route key="/users" path="/users" element={<UserList />} />
                <Route key="/user/:id" path="/user/:id" element={<UserDetails />} />
                <Route key="/user/:id/roles" path="/user/:id/roles" element={<UserRole />} />
                <Route
                    key="/user/:id/roles/update"
                    path="/user/:id/roles/update"
                    element={<UpdateUserRoles />}
                />
                <Route key="/user/:id/groups" path="/user/:id/groups" element={<UserGroup />} />
                <Route
                    key="/user/:id/groups/update"
                    path="/user/:id/groups/update"
                    element={<UpdateUserGroups />}
                />
                <Route key="/roles" path="/roles" element={<RoleList />} />
                <Route key="/role/:id" path="/role/:id" element={<RoleDetails />} />
                <Route key="role" path="role" element={<CreateRole />} />
                <Route key="/groups" path="/groups" element={<GroupList />} />
                <Route key="/group/:id" path="/group/:id" element={<GroupDetails />} />
                <Route key="/group" path="/group" element={<CreateGroup />} />
                <Route key="/envelopes" path="/envelopes" element={<EnvelopeList />} />
                <Route key="/templates" path="/templates" element={<TemplateList />} />
                <Route
                    key="/template-details/:id"
                    path="/template-details/:id"
                    element={<TemplateDetails />}
                />
                <Route
                    key="/template/:id/envelopes"
                    path="/template/:id/envelopes"
                    element={<TemplateEnvelopeList />}
                />
                <Route key="/forms" path="/forms" element={<FormList />} />
                <Route key="/form-details/:id" path="/form-details/:id" element={<FormDetails />} />
                <Route key="/envelope/:id" path="/envelope/:id" element={<EnvelopeDetail />} />
                <Route key="/admins" path="/admins" element={<AdminList />} />
                <Route key="/settings" path="/settings" element={<Setting />} />
                <Route key="/brands" path="/brands" element={<BrandList />} />
                <Route key="/brand/add" path="/brand/add" element={<AddBrand />} />
                <Route key="/brand/:id" path="/brand/:id" element={<BrandDetails />} />
                <Route key="/invite-users" path="/invite-users" element={<InviteUser />} />
                <Route key="/my-profile" path="/my-profile" element={<Profile />} />
                <Route key="/register/azure" path="/register/azure" element={<AzureRegistration />} />
                <Route key="/role/:id/edit" path="/role/:id/edit" element={<EditRole />} />
                <Route key="/group/:id/edit" path="/group/:id/edit" element={<EditGroup />} />
                <Route key="/directory" path="/directory" element={<DirectoryService />} />
                <Route key="/shared-access/:id" path="/shared-access/:id" element={<SharedAccess />} />
                <Route
                    key="/shared-access/:id/create"
                    path="/shared-access/:id/create"
                    element={<CreateSharedAccess />}
                />
                <Route key="/logs" path="/logs" element={<AuditLogs />} />
                <Route key="/manage-ai" path="/manage-ai" element={<ManageAi />} />
                <Route key="/manage-ai/:id" path="/manage-ai/:id" element={<AiConfigurations />} />
                <Route key="/reported-users" path="/reported-users" element={<ReportedUsers />} />
                <Route
                    key="/reported-user/:id"
                    path="/reported-user/:id"
                    element={<ReportedUserDetail />}
                />
                <Route
                    key="/reported-envelope/:id"
                    path="/reported-envelope/:id"
                    element={<ReportedEnvelopeDetails />}
                />
                <Route key="/tags" path="/tags" element={<TagsList />} />
            </Routes>
        </div>
    );
};

export default SideBarRoutes;
